import { createAction } from '@reduxjs/toolkit';

const saveOptionalExtrasFormValues = createAction(
  'ui/sealink/journey/saveOptionalExtrasFormValues'
);

export { saveOptionalExtrasFormValues };
